<script lang="ts" setup>
withDefaults(defineProps<{
    disabled?: boolean
    id: string
    modelValue: string
    name: string
    value: string
  }>(),
  {
    disabled: false
  }
)

defineEmits(['update:modelValue'])
</script>

<template>
  <input
    :id="id"
    :checked="modelValue === value"
    :disabled="disabled"
    :name="name"
    :value="value"
    class="radio-button"
    type="radio"
    @change="$emit('update:modelValue', value)"
  >
</template>

<style lang="scss" scoped>
@import '@/assets/style/helpers/include-media';

.radio-button {
  appearance: none;
  z-index: 1;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 1.8rem;
  width: 1.5rem;
  height: 1.5rem;
  min-width: 1.5rem;
  margin: auto rem-calc(5) auto 0;
  border-radius: 50%;
  border: 1px solid $borderColor;
  opacity: 1;

  @include media('>=desktop') {
    left: 2.3rem;
  }

  &:hover {
    background: white;
    border-color: $activeBorderColor;
    cursor: pointer;
  }

  &:checked {
    @include themify($themes) {
      border: 8px solid themed('primaryColor');
    }
  }
}
</style>
